export const tr = {
    'mutation-warning': 'İşlem normalden uzun sürüyor. Değişiklikleri görmek için bir süre bekleyip sayfayı yenileyin.',
    'request-error': 'Sayfayı yenileyin veya daha sonra girmeyi deneyin'
};
